module.exports = __webpack_public_path__ + "static/media/rolefitment.c721be7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rolefitment.png
// module id = 891
// module chunks = 0